import axios from "axios";

const axiosInstance = axios.create({
  // baseURL: "http://localhost:5000", // localhost
 baseURL: "https://carwarranty-backend.onrender.com/" // hosted
  //  baseURL: "https://carwarranty-backend.adaptable.app/" //sid hosted
});

export default axiosInstance;
